export const TILES_RESOLUTION_DELAY = 650;
